export enum AttachmentState {
  Uploaded = 1,
  CheckInProgress = 2,
  VirusDetected = 3,
  VirusNotDetected = 4,
  Downloaded = 5,
  GeneratedByPecManager = 6,
}
